import { PropsWithChildren } from "react";

export const GuidelineContainer = (props: PropsWithChildren<any>) => (
    <ul className="ds-u-font-size--base ds-u-margin-y--0 ds-u-padding-x--3">
        {props.children}
    </ul>
);